module.exports = __webpack_public_path__ + "assets/img/goods-demo01.ca4b7a16.png";